import { JsonObject, JsonProperty } from 'json2typescript';

import { Loan } from './loan.model';

@JsonObject('loanFamily')
export class LoanFamily {
  @JsonProperty('idFamillePret', String, true)
  public familyId = '';

  @JsonProperty('libFamillePret', String, true)
  public familyName = '';

  @JsonProperty('libMarketCommentaire', String, true)
  public marketComment = '';

  @JsonProperty('objetPret', [Loan], true)
  public loans: Loan[] = [];
}
